import { useDevicesByType } from 'app/agriculture/queries/devices/useDevicesByType';
import { TankLevelChart } from 'app/agriculture/routes/Tanks/TankDetails/components/TankLevelChart/TankLevelChart';
import { useMemo } from 'react';

export function TankLevelChartComponent({ tankId }: { tankId: string }) {
    const devices = useDevicesByType('Level Monitor');
    const attachedDevice = useMemo(
        () =>
            [...devices.values()].find(({ infrastructureId }) => infrastructureId === tankId) ??
            null,
        [devices, tankId],
    );

    if (!attachedDevice) {
        return null;
    }

    return <TankLevelChart deviceId={attachedDevice.id} />;
}
